import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { CreateLiveDocOnboardingItem } from './CreateLiveDocOnboardingItem.tsx';
import { CreatePageOnboardingItem } from './CreatePageOnboardingItem.tsx';
import { CreateWhiteboardOnboardingItem } from './CreateWhiteboardOnboardingItem.tsx';
import { CreateDatabaseOnboardingItem } from './CreateDatabaseOnboardingItem.tsx';

type ContentTreeOnboardingProps = {
	showLiveDoc: boolean;
	showWhiteboard: boolean;
	showDatabase: boolean;
};

export const ContentTreeOnboarding = ({
	showLiveDoc,
	showWhiteboard,
	showDatabase,
}: ContentTreeOnboardingProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				actionSubject: 'contentTreeOnboarding',
				action: 'shown',
				source: 'contentTreeOnboarding',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return (
		<>
			{showLiveDoc && <CreateLiveDocOnboardingItem />}
			<CreatePageOnboardingItem />
			{showWhiteboard && <CreateWhiteboardOnboardingItem />}
			{showDatabase && <CreateDatabaseOnboardingItem />}
		</>
	);
};
